<template>
  <div
    id="object-map"
    :style="'width: 100%; height: 400px;'"
  />
</template>

<script>
export default {
  name: 'Map',

  data () {
    return {
      showMap: false
    }
  },

  props: {
    mapCoords: {
      type: Object,
      default: () => {}
    }
  },

  created () {
    this.$nextTick(() => {
      this.initMap()
    })
  },

  methods: {
    initMap () {
      let location = this.mapCoords
      google.maps.visualRefresh = false
      let map = new google.maps.Map(
        document.getElementById('object-map'), { zoom: 12, center: location }
      )
      let marker = new google.maps.Marker({ position: location, map: map })

      // Add "Open Google Maps" button
      let gotoMapButton = document.createElement("div")
      gotoMapButton.setAttribute("style", "margin: 5px; border: 1px solid #ccc; padding: 5px 12px; font: 13px Roboto, Arial, sans-serif; color: #000000; background-color: #FFFFFF; cursor: pointer;");
      gotoMapButton.innerHTML = "Open Google Maps";
      map.controls[google.maps.ControlPosition.TOP_RIGHT].push(gotoMapButton)
      google.maps.event.addDomListener(gotoMapButton, "click", function () {
          var url = 'https://www.google.com/maps?q=' + encodeURIComponent(marker.getPosition().toUrlValue())
          window.open(url)
      })
    },
  },
}
</script>
